import React from 'react';
import { Box, Typography } from '@mui/material';
import ReportLegend from "./ReportLegend";

// NewBanner component
interface NewBannerProps {
    titleLabel: string;
    showLegend?: boolean;
}

const NewBanner: React.FC<NewBannerProps> = ({
    titleLabel,
    showLegend = false
}) => {
    return (
        <Box sx={{
            color: 'primary.main',
            pb: 2,
            borderRadius: '4px 4px 0 0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }}>
            <Typography variant="h4" component="h1">
                {titleLabel}
            </Typography>
            {showLegend && ReportLegend(true)}
        </Box>
    );
};

export default NewBanner;